import { Component, HostBinding } from '@angular/core';
import * as i0 from "@angular/core";
export class HiddenRenderingComponent {
    get style() {
        return 'background-image: linear-gradient(45deg, #ffffff 25%, #dcdcdc 25%, #dcdcdc 50%, #ffffff 50%, #ffffff 75%, #dcdcdc 75%, #dcdcdc 100%); background-size: 3px 3px; display: block; height: 100px;';
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HiddenRenderingComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: HiddenRenderingComponent, selector: "sc-hidden-rendering", host: { properties: { "style": "this.style" } }, ngImport: i0, template: '', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HiddenRenderingComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sc-hidden-rendering',
                    template: '',
                }]
        }], propDecorators: { style: [{
                type: HostBinding,
                args: ['style']
            }] } });
export const HIDDEN_RENDERING_NAME = 'Hidden Rendering';
